export const THEME_STORAGE_KEY = "ultimate-course-counter-theme-v1"

/** Preset themes (ids match `.counterWrapper--theme-{id}` in SCSS). */
export const COUNTER_THEMES = [
 { id: "teal", label: "Arctic teal", description: "Original cool teal" },
 { id: "ocean", label: "Deep ocean", description: "Navy blue depths" },
 { id: "forest", label: "Forest night", description: "Muted evergreen" },
 { id: "plum", label: "Royal plum", description: "Soft violet dusk" },
 { id: "ember", label: "Warm ember", description: "Bronze and rust" },
 { id: "slate", label: "Graphite slate", description: "Cool neutral gray" },
 { id: "midnight", label: "Midnight luxe", description: "Charcoal & steel blue" },
 { id: "burgundy", label: "Velvet burgundy", description: "Deep wine & rose" },
 { id: "sapphire", label: "Royal sapphire", description: "Jewel cobalt blue" },
 { id: "obsidian", label: "Obsidian zen", description: "Onyx with teal gleam" },
 { id: "champagne", label: "Champagne dusk", description: "Bronze & warm gold" },
 { id: "orchid", label: "Silk orchid", description: "Mauve & soft plum" },
 { id: "porcelain", label: "Porcelain sage", description: "Light mint paper" },
 { id: "dawn", label: "Dawn parchment", description: "Warm cream & sand" }
]

export function getValidThemeId(id) {
 if (COUNTER_THEMES.some((t) => t.id === id)) return id
 return "teal"
}
